import { render, staticRenderFns } from "./OtherFeatureCardView.vue?vue&type=template&id=f3d3033c&scoped=true"
import script from "./OtherFeatureCardView.vue?vue&type=script&lang=ts"
export * from "./OtherFeatureCardView.vue?vue&type=script&lang=ts"
import style0 from "./OtherFeatureCardView.vue?vue&type=style&index=0&id=f3d3033c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d3033c",
  null
  
)

export default component.exports